import React from 'react';
import { Button, Grid2 } from '@mui/material';
import Banner from '../Components/banner';
import Header from '../Components/Header.jsx';
import bgVideo from '../Banners/background.mp4';
import styles from "../styles/Home.css";
import { useEffect, useRef } from 'react';
import Card from '../Components/Card.jsx';
import Footer from '../Components/Footer.jsx';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import FloatingWhats from '../Components/FloatingWhats.jsx';
import { useNavigate } from 'react-router-dom';
import BottomBar from '../Components/BottomBar.jsx';


const Home  = () => {

    const videoRef = useRef(null);
    useEffect(() => {
        if (videoRef.current) {
          videoRef.current.playbackRate = 0.5; // metade da velocidade
        }
      }, []);


    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>
            <div className="banner-container">
                <video ref={videoRef} width="100%" height="910px" className='banner-video' autoPlay loop muted>
                    <source src={bgVideo} type="video/mp4" />
                    Seu navegador não suporta vídeo.
                </video>
                <div className="banner-content from-left">
                    <div className="banner-block">
                        <div className="banner-block-content">
                            <h4 className='banner-subtitle'>Solução Tecnológica</h4>
                            <div className="banner-line"/>
                            <h1 className='banner-title'>O Futuro da Pesagem é Balanças Cuiabá.</h1>
                            <h2 className='banner-text'>Com nossa tecnologia de ponta em pesagens garantimos a precisão e confiabilidade que você tanto procura!</h2>
                            <a href='/balancas-cuiaba'><Button sx={{fontFamily:'Inter', height:'90px', width:'100%', border:'solid #474747 3px', borderRadius:'8px', color:'#474747', textTransform:'none', backgroundColor:'transparent', fontWeight:'700', fontSize:'20px','&:hover':{color:'#fff', backgroundColor:'#474747'}}}>Conheça mais sobre nós</Button></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="ourClients from-bottom">
                    <div className="ourClients-content">
                        <h3 className="ourClients-title">
                            <span style={{color:'#474747'}}>NOSSOS </span>
                            <span style={{color:'#9E1518'}}>CLIENTES</span>
                        </h3>
                        <div className="ourClients-carousel">
                            <div className="logo-track">
                                <img className='client-logo' src='/images/logos/amaggi.png'/>
                                <img className='client-logo' src='/images/logos/brf.png'/>
                                <img className='client-logo' src='/images/logos/bunge.png'/>
                                <img className='client-logo' src='/images/logos/cargill.png'/>
                                <img className='client-logo' src='/images/logos/coopavel.png'/>
                                <img className='client-logo' src='/images/logos/lar.png'/>
                                <img className='client-logo' src='/images/logos/primato.png'/>
                            </div>
                            <div className="ourClients-bar"/>
                        </div>
                    </div>
                </div>
                <div className="home1">
                    <div className="home1-content">
                        <div className="home1-left from-left">
                            <h4 className="home1-subtitle from-left">
                                EFICIÊNCIA APLICADA
                            </h4>
                            <h1 className='home1-title from-left'>
                                Otimize suas operações<br/>com nossa automação.
                            </h1>
                            <a href='#' className='home0-link from-left'>
                                <img className='home0-link-icon' src='/images/icons/arrow-right.svg'/>
                                <span>Mais Informações</span>
                            </a>
                            <div className="home1-depo">
                                <div className="home1-depo-bar"/>
                                <div className="home1-depo-content">
                                    {/* <img className='home1-depo-logo' src='/images/logos/coopavel.png'/> */}
                                    <span className='home1-depo-text'>
                                        “Sempre fui atendido com muita rapidez e comprometimento com o resultado. Hoje, quase três anos depois, posso afirmar que essa parceria foi a melhor coisa que fiz, por isso recomendo, com muita satisfação, o trabalho dessas pessoas maravilhosas, que além de profissionais gabaritadas, nos atendem com muita dedicação.”
                                    </span>
                                    <div className="home1-depo-photo">
                                        <img className='home1-depo-photo-img' src='/images/depophoto.png'/>
                                        <div className="home1-depo-info">
                                            <span className='home1-depo-name'>Marcos Souza</span>
                                            <span className='home1-depo-position'>Gerente de Logística</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="home1-right from-right">
                            <img className='home1-right-img' src='/images/275627.png'/>
                        </div>
                    </div>
                </div>
                <div className="home2">
                    <div className="home2-content1">
                        <div className="home2-left from-left">
                            <img className='home2-left-img' src='/images/brc3.png'/>
                        </div>
                        <div className="home2-right">
                            <h4 className="home1-subtitle from-right">
                                CÉLULA DE CARGA - PRODUTO EXCLUSIVO
                            </h4>
                            <h1 className='home1-title from-right'>
                                BRC3
                            </h1>
                            <a href='/produtos/pesagem-rodoviaria/celula-brc3a' className='home0-link from-right'>
                                <img className='home0-link-icon' src='/images/icons/arrow-right.svg'/>
                                <span>Mais Informações</span>
                            </a>
                            <div className="home2-topics from-right">
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3-1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Construída em aço inoxidável, que proporciona resistência à corrosão, tornando-se durável, mesmo em ambientes com condições adversas.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3-2.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Máxima proteção contra infiltração de água, mesmo com o uso de jatos de alta pressão ou limpeza a vapor.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3-3.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>As castanhas anti rotação tornam a montagem mais segura e resistente, além de permitir movimentação lateral com até 3° de inclinação.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                            </div>
                        </div>
                    </div>
                    <div className="home2-content2">
                        <div className="home2-left from-right">
                            <img className='home2-left-img' src='/images/brc3d.png'/>
                        </div>
                        <div className="home2-right">
                            <h4 className="home1-subtitle from-left">
                                CÉLULA DE CARGA - PRODUTO EXCLUSIVO
                            </h4>
                            <h1 className='home1-title from-left'>
                                BRC3 - Digital
                            </h1>
                            <a href='/produtos/pesagem-rodoviaria/celula-brc3d' className='home0-link from-left'>
                                <img className='home0-link-icon' src='/images/icons/arrow-right.svg'/>
                                <span>Mais Informações</span>
                            </a>
                            <div className="home2-topics from-left">
                            <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3d-1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Com capacidade para até 50t, torna-se adequada para uma ampla gama de aplicações.</span>
                                    </div>
                                    
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3-1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Cápsula em aço inoxidável, maior durabilidade com o máximo grau de proteção a poeira, jatos de água, vapor de alta pressão e alta temperatura.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3d-3.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Comunicação via sinal Digital, proporcionando maior estabilidade e menor interferência.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                            </div>
                        </div>
                    </div>
                    <div className="home2-content1">
                        <div className="home2-left from-left">
                            <img className='home2-left-img' src='/images/pdx.png'/>
                        </div>
                        <div className="home2-right">
                            <h4 className="home1-subtitle from-right">
                                CÉLULA DE CARGA
                            </h4>
                            <h1 className='home1-title from-right'>
                                METTLER TOLEDO - PDX
                            </h1>
                            <a href='/produtos/pesagem-rodoviaria/celula-pdx' className='home0-link from-right'>
                                <img className='home0-link-icon' src='/images/icons/arrow-right.svg'/>
                                <span>Mais Informações</span>
                            </a>
                            <div className="home2-topics from-right">
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3-1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Proteção garantida contra raios, descargas elétricas, inundação, barro e poeira com a tecnologia Mettler Toledo.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3-2.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Redução de manutenção em até 50%, trazendo mais confiabilidade e durabilidade do equipamento, garantindo a funcionalidade da balança.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/brc3-3.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Precisão 3x maior nas pesagens que as demais células de carga no mercado.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                            </div>
                        </div>
                    </div>
                    <div className="home2-content2">
                        <div className="home2-left from-right">
                            <img className='home2-left-img' src='/images/bsds.png'/>
                        </div>
                        <div className="home2-right">
                            <h4 className="home1-subtitle from-left">
                                CÉLULA DE CARGA
                            </h4>
                            <h1 className='home1-title from-left'>
                                BSDS
                            </h1>
                            <a href='/produtos/pesagem-rodoviaria/celula-bsds' className='home0-link from-left'>
                                <img className='home0-link-icon' src='/images/icons/arrow-right.svg'/>
                                <span>Mais Informações</span>
                            </a>
                            <div className="home2-topics from-left">
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/bsds-1.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Construída em aço inoxidável com grau de proteção IP69K, possuindo máxima proteção contra infiltração de água.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/bsds-2.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Com certificado de precisão C4, emitido pela NMi Certin B.V. (Holanda), a BSDS é reconhecida internacionalmente, com os padrões da OIML.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                                <div className="home2-middle">
                                    <div className="home2-middle-icon">
                                        <img src='/images/icons/bsds-3.svg'/>
                                    </div>
                                    <div className="home2-middle-text">
                                        <span className='home2-middle-title'>Testada contra transientes elétricos de 80kA, ou seja, é extremamente robusta eletricamente, podendo até mesmo suportar raios sem danificar.</span>
                                    </div>
                                </div>
                                <div className="home2-bar"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="home3">
                    <div className="home3-content from-bottom">
                        <Grid2 columns={{ xs:4, sm:8, md:12}} container spacing={2} justifyContent={'center'}>
                            <Grid2 item>
                                <div className="home3-block from-bottom">
                                    <img className='home3-icon' src='/images/icons/award.svg'/>
                                    <span className='home3-title'>Qualidade<br/>comprovada</span>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="home3-block from-bottom">
                                    <img className='home3-icon' src='/images/icons/brasil.svg'/>
                                    <span className='home3-title'>Atendemos<br/>todo o mercosul</span>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="home3-block from-bottom">
                                    <img className='home3-icon' src='/images/icons/24h.svg'/>
                                    <span className='home3-title'>Assitência<br/>24h</span>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="home3-block from-bottom">
                                    <img className='home3-icon' src='/images/icons/atendimento.svg'/>
                                    <span className='home3-title'>Atendimento<br/>especializado</span>
                                </div>
                            </Grid2>
                        </Grid2>
                    </div>
                </div>
                <div className="home4">
                    <div className="home4-content">
                        <h3 className="home4-title from-bottom">
                            <span style={{color:'#474747'}}>O PRODUTO CERTO </span>
                            <span style={{color:'#9E1518'}}>PARA CADA NECESSIDADE</span>
                        </h3>
                        <Grid2 className="from-bottom" columns={{ xs:4, sm:8, md:12}} container spacing={5} justifyContent={'center'}>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria' cardImg={`/images/pesagem-rodoviaria.png`} title='Pesagem Rodoviária'/>
                            </Grid2>
                            {/* <Grid2 item>
                                <Card link='/produtos/tulhas-e-balancas-de-fluxo' cardImg={`/images/tulha-fluxo.png`} title='Tulhas e Balanças de Fluxo'/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/linha-industrial' cardImg={`../images/linha-industrial.png`} title='Linha Industrial'/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/automacao-rodoviaria' cardImg={`/images/automacao-rodoviaria.png`} title='Automação Rodoviária'/>
                            </Grid2> */}
                        </Grid2>
                    </div>
                </div>
                <div className="home5">
                    <div className="home5-content from-bottom">
                        <div className="home5-left from-left">
                            <img className='home5-oldTruck' src='/images/oldTruck.png'/>
                            <img className='home5-newTruck' src='/images/newTruck.png'/>
                            <div className="home5-dots"/>
                            <div className="home5-right-text">
                                <span className='home5-truck-text1'>+25</span>
                                <br/>
                                <span className='home5-truck-text2'>anos entregando<br/>solução e inovação</span>
                            </div>
                        </div>
                        <div className="home5-right from-right">
                            <h2 className='home5-title'>Quem somos</h2>
                            <h4 className='home5-text'>Com mais de 25 anos de mercado, a Balanças Cuiabá é referência nacional no segmento de pesagens da agroindústria, contamos hoje com uma moderna fábrica na cidade de Cascavel no Oeste do Paraná. Atuamos com foco em qualidade, inovação e confiabilidade em nossas pesagens, oferecendo soluções eficientes para toda a agroindústria nacional.</h4>
                            <a href='/balancas-cuiaba'><Button sx={{paddingLeft:'15px',fontFamily:'Inter', height:'50px', width:'300px', borderRadius:'50px', color:'#fff', textTransform:'none', backgroundColor:'#474747', fontWeight:'700', fontSize:'16px','&:hover':{backgroundColor:'#9E1518'}}}>Conheça a Balanças Cuiabá<img className='home5-link-icon' src='/images/icons/chevron-right.svg'/></Button></a>
                        </div>
                    </div>
                </div>
                <div className="work-container">
                    <div className="work-content from-bottom">
                        <h3 className='work-title'>Trabalhe Conosco</h3>
                        <div className="work-line"/>
                        <div className="work-subtitle">Venha fazer parte da nossa equipe!</div>
                        <div className="work-links">
                            <a href='https://linkedin.com/company/balancascuiaba'><img src="/images/icons/linkedin.svg" className="linkedIn"/></a>
                            <a href='https://infojobs.com'><img src="/images/icons/ij.svg" className="infoJobs" style={{width:'33px'}}/></a>
                        </div>
                    </div>
                </div>

                <div className="depoContainer">
                    <div className="depoContent">
                        <h3 className="ourClients-title from-bottom">
                            <span style={{color:'#474747'}}>ALGUNS DEPOIMENTOS </span>
                            <span style={{color:'#9E1518'}}>DE NOSSOS CLIENTES</span>
                        </h3>                        
                        <Grid2  container spacing={4} justifyContent={'center'} className='from-bottom' >
                            <Grid2 item>
                                <div className="depoCardContainer">
                                    <div className='depoCardFoto'>F</div>
                                    <div className="depoCardText">
                                        <div className="depoCardName">Fernanda de Abreu</div>
                                        Excelente atendimento e equipamentos de alta qualidade. A Balanças Cuiabá entregou exatamente o que precisávamos, com rapidez e profissionalismo. Recomendo para quem busca confiança e eficiência.
                                    </div>
                                    <img src='/images/icons/aspas.svg' className='aspasUp'/>
                                    <img src='/images/icons/aspas.svg' className='aspasDown'/>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="depoCardContainer">
                                    <div className='depoCardFoto'>O</div>
                                    <div className="depoCardText">
                                        <div className="depoCardName">Otávio Lima Neto</div>
                                        Empresa séria e comprometida. Produtos confiáveis e serviço impecável. Ficamos muito satisfeitos com o resultado e com o atendimento prestado.
                                        
                                    </div>
                                    <img src='/images/icons/aspas.svg' className='aspasUp'/>
                                    <img src='/images/icons/aspas.svg' className='aspasDown'/>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="depoCardContainer">
                                    <div className='depoCardFoto'>F</div>
                                    <div className="depoCardText">
                                        <div className="depoCardName">Franciele de Souza</div>
                                        Ótima experiência do início ao fim. Equipe atenciosa, instalação rápida e suporte sempre disponível. A Balanças Cuiabá realmente entende do assunto.
                                        
                                    </div>
                                    <img src='/images/icons/aspas.svg' className='aspasUp'/>
                                    <img src='/images/icons/aspas.svg' className='aspasDown'/>
                                </div>
                            </Grid2>
                        </Grid2>                            
                    </div>
                </div>
                <BottomBar/>
                <Footer/>
            </div>
        </div>
    );
}
export default Home;